module.exports = __webpack_public_path__ + "static/media/stream_Mindfresh_video_classes.500c2d65.svg";